<div>
	<h1>{{ $t('vm.root.user.stripe-subscription.title') }}</h1>
    <div v-if="isDemo">
		<stripe-subscription-cancel-alert
			id="stripe-subscription-alert1"
		>
			<div class='notice-warning'>
				<p class="text-left">
					<i18n :path="'vm.root.user.stripe-subscription.demo.text'" tag="p">
						<svg width="1em" class="svg-middle" viewBox="0 0 576 512" aria-hidden="true">
							<use xlink:href="@Assets/svg/symbol-defs.svg#exclamation-triangle" />
						</svg>
					</i18n>
				</p>
			</div>
		</stripe-subscription-cancel-alert>
	</div>
	<div v-else>
		<div v-if="canShowSubscriptionInfos">
			<section class="bordered-panel marg-v">
				<header class="childs-space-between">
					<h2 class="text-md text-capitalize no-marg">{{ subscriptionTitle }}</h2>

					<span
						:class="['is-pushed-right', isExpired ? 'tag-danger' : 'tag-success']"
					>
						{{ $t(isExpired
						? 'vm.root.user.stripe-subscription.expired'
						: 'vm.root.user.stripe-subscription.active'
					) }}
					  </span>
				</header>

				<p class="marg-t">{{ subscriptionExpirationText }}</p>

				<div class="text-right">
					<button
						type="button"
						class="btn--link-like"
						:title="$t('vm.root.user.stripe-subscription.cancel-subscription.title')"
						@click.prevent="cancelSubscription"
						:disabled="isSubscriptionCanceled"
					>
						{{ $t('vm.root.user.stripe-subscription.cancel-subscription.label') }}
					</button>
				</div>

			</section>
			<stripe-subscription-cancel-alert
				id="stripe-subscription-alert"
				v-if="isSubscriptionCanceled"
			>
				<div class='notice-danger'>
					<p class="text-left">
						<i18n :path="'vm.root.user.stripe-subscription.cancel-subscription.alert'" tag="p">
							<svg width="1em" class="svg-middle" viewBox="0 0 576 512" aria-hidden="true">
								<use xlink:href="@Assets/svg/symbol-defs.svg#exclamation-triangle" />
							</svg>
							<b>{{canceledInitDate}}</b>

						</i18n>
					</p>
				</div>
			</stripe-subscription-cancel-alert>
		</div>
		<div v-else>
			<section>
				<stripe-subscription-cancel-alert
					id="stripe-subscription-alert2"
				>
					<div class='notice-warning'>
						<p class="text-left">
							<i18n :path="'vm.root.user.stripe-subscription.no-license.text1'" tag="p">
								<svg width="1em" class="svg-middle" viewBox="0 0 576 512" aria-hidden="true">
									<use xlink:href="@Assets/svg/symbol-defs.svg#exclamation-triangle" />
								</svg>
								<router-link
									:to="{ name: 'shop' }"
									:title="$t('vm.root.user.stripe-subscription.no-license.title')">
									{{ $t('vm.root.user.stripe-subscription.no-license.text2') }}
								</router-link>

							</i18n>
						</p>
					</div>
				</stripe-subscription-cancel-alert>
			</section>
		</div>
	</div>

</div>
